import React from 'react';

const features = [
  {
    title: 'Rendimiento Ultra-Rápido',
    desc: 'Optimizado para cargar en menos de 2 segundos en cualquier conexión.',
    icon: <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" />,
  },
  {
    title: 'UI/UX Premium',
    desc: 'Interfaces intuitivas que convierten visitantes en clientes fieles.',
    icon: <><rect x="3" y="3" width="18" height="18" rx="2" /><path d="M3 9h18M9 21V9" /></>,
  },
  {
    title: 'Seguridad Blindada',
    desc: 'SSL, encriptación y las mejores prácticas de seguridad web.',
    icon: <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />,
  },
];

const MobileSection = () => (
  <section className="mobile-section" id="movil">
    <div className="mobile-section__inner">
      <div className="mobile-visual reveal">
        <div className="phone-glow" />
        <div className="phone-mockup">
          <div className="phone-mockup__notch" />
          <div className="phone-mockup__screen">
            <div className="phone-mockup__content">
              <div className="phone-mockup__header">MONOLOGIC</div>
              <div className="phone-bar phone-bar--1" />
              <div className="phone-bar phone-bar--2" />
              <div className="phone-bar phone-bar--3" />
              <div className="phone-bar phone-bar--4" />
              <div className="phone-card-mini">
                <div className="phone-card-mini__avatar" />
                <div className="phone-card-mini__line phone-card-mini__line--1" />
                <div className="phone-card-mini__line phone-card-mini__line--2" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="mobile-content reveal">
        <div className="section-label">Experiencia Móvil</div>
        <h2 className="section-title">DISEÑO QUE SE<br />ADAPTA</h2>
        <p className="section-sub">
          Cada proyecto es 100% responsive, garantizando una experiencia impecable en cualquier dispositivo.
        </p>
        {features.map((f, i) => (
          <div className="mobile-feature" key={i}>
            <div className="mobile-feature__icon">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                {f.icon}
              </svg>
            </div>
            <div>
              <h3 className="mobile-feature__title">{f.title}</h3>
              <div className="mobile-feature__desc">{f.desc}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default MobileSection;
